import { render } from "./IconTiktok.vue?vue&type=template&id=11219b26"
import script from "./IconTiktok.vue?vue&type=script&lang=js"
export * from "./IconTiktok.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__